export default __webpack_public_path__ + "static/media/transformation.3069bb15.gif";